import { defineComponent, type PropType } from "vue";

import BaseControl from "./BaseControl";
export default defineComponent({
  extends: BaseControl,
  watch: {
    "state.value": {
      handler(newValue, oldValue) {
        this.state.previousValue = oldValue;
        if (!this.state.silentValueChangeEvent) {
          window.FormEngine.events.publish(
            window.FormEngine.events.list.VALUE_CHANGE,
            {
              control: this,
              from: oldValue,
              to: newValue,
            },
            this.identifier
          );
        } else {
          this.state.silentValueChangeEvent = false;
        }
        if (!this.state.silentSetValue) {
          this.validate(this.fillErrorBagComputed);
        } else {
          this.state.silentSetValue = false;
        }
      },
      deep: true,
    },
  },
});
